import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand, randChanceBoolean } from '@ngneat/falso'

import type { SchemaAttributes } from '../../types.js'
import type { MockServer } from '../server.js'
import { getTodayDateTimeISO } from '@/utils/date/getter.js'
import { CONSTANTS } from './constants.js'

export type MessageReceiptData = SchemaAttributes<'ConversationMessageReceipt'>

export const model = (Model as ModelDefinition<MessageReceiptData>).extend({
  message: belongsTo('message'),
  participant: belongsTo('participant'),
})

export const factory = Factory.extend<MessageReceiptData>({
  status() {
    // 50% of receipts use default status (sent), 50% use random status
    return randChanceBoolean({ chanceTrue: 0.5 })
      ? CONSTANTS.messageReceipt.defaultStatus
      : rand([...CONSTANTS.messageReceipt.statuses])
  },
  error_code() {
    return null
  },
  created_at() {
    return getTodayDateTimeISO()
  },
  updated_at() {
    return getTodayDateTimeISO()
  },
})

export function routes(server: MockServer) {
  server.resource('messageReceipt')
}

export function seeds() {}
